<template>
    <div>
      <div class="chat-container scrollable" ref="chatContainer">
        <Message :conversation="conversation" @joinRTC="joinRTC"></Message>
      </div>
      <v-divider></v-divider>
      <div class="typer">
        <input
          type="text"
          placeholder="new message..."
          v-on:keyup.enter="sendMessage"
          v-model="content"
          :enabled="sending"
        />
        </div>
    </div>
</template>

<script>
import Message from '@/components/Message.vue';
import { mapGetters } from 'vuex'

export default {
  name: 'chat',
  data () {
    return {
      content: '',
      sending: false
    }
  },
  components: { Message },
  props: { conversation: Object },
  methods: {
    joinRTC (sessionId) {
      console.log('emit joinRTC')
      this.$emit('joinRTC', sessionId)
    },
    async loadItems () {
      this.loadingItems = true
      try {
        await this.$store.dispatch('hearro/loadConversationItems', { conversationId: this.conversation.data.id })
      } catch (e) {
        console.log(e)
      } finally {
        this.loadingItems = false
      }
    },
    async sendMessage () {
      if (this.content === '') { return }
      this.sending = true
      if (this.content.substring(0, 1) === '/') {
        // parse the "/" command
        this.$store.dispatch('hearro/newRTCSession', { conversationId: this.conversation.data.id })
      } else {
        try {
          this.$store.dispatch('hearro/sendConversationMessage', { conversationId: this.conversation.data.id, body: this.content })
        } catch (e) {
          console.log(`error sending message ${e.message}`)
        } finally {
          this.content = ''
          this.sending = false
        }
      }
    }
  },
  computed: {
    showDrawer () {
      return (this.btnActions === 0)
    },
    ...mapGetters('hearro', [
      'conversationParticipants',
      'connections'
    ])
  }
}
</script>

<style scoped>
.scrollable {
  overflow-y: auto;
  overflow-x: hidden;
}
.typer {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  bottom: 0;
  width: 100%;
  background-color: #fff;
  box-shadow: 0 -5px 10px -5px rgba(0, 0, 0, 0.2);
}
.typer input[type="text"] {
  /* position: absolute; */
  left: 2.5rem;
  padding: 1rem;
  width: 80%;
  background-color: transparent;
  border: none;
  outline: none;
  font-size: 1.25rem;
}
.chat-container {
  box-sizing: border-box;
  height: calc(100vh - 210px);
  overflow-y: auto;
  padding: 10px;
  background-color: #f2f2f2;
}
@media (max-width: 480px) {
  .chat-container .content {
    max-width: 60%;
  }
}
</style>
